import React from 'react'

import ModularForm from '../../../react4xp/components/ModularForm'

function CampaignFormPart({ title, fields, submitUrl, strings, bgColor }) {
	return (
		<ModularForm
			section={{
				bgColor: bgColor,
				paddingTop: 'big'
			}}
			title={title}
			submit={{
				label: strings.sendButton,
				url: submitUrl
			}}
			cancelLabel={strings.cancelButton}
			fields={fields}
			strings={strings}
		/>
	)
}

export default (props) => <CampaignFormPart {...props} />
